// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"69651e00","742":"7cec31e6","928":"7cec31e6"}[chunkId] + ".chunk.css";
};